import moment from "moment";
import dayjs from "dayjs";
import { useCallback, useRef } from "react";
export const formatDate = (value) => {

  const formattedDate = dayjs(value).format('YYYY-MM-DD');

  return formattedDate;
}
export const formatDate1 = (dateString) => {
  const [day, month, year] = dateString.split(/[\/\s:]/);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${day}-${months[parseInt(month, 10) - 1]}-${year}`;
};
export const formatDate2 = (value) => {

  const formattedDate = dayjs(value).format('DD-MM-YYYY');

  return formattedDate;
}
export const focusElemnt = (elementID) => {
  elementID &&
    document.getElementById(elementID) &&
    document.getElementById(elementID).focus();
};

export const clickElement = (elementID) => {
  elementID && document.getElementById(elementID) && document.getElementById(elementID).click()
}
export const navigation1 = (e, nextId, prevId) => {
  if (e.key === "Escape") {
    focusElemnt(prevId);
  }
  if (e.key === "Enter") {
    focusElemnt(nextId);
    e.preventDefault();
  }
};
export const navigation2 = (e, nextId, prevId) => {
  if (e.key === "Escape" || e.key === "ArrowUp") {
    focusElemnt(prevId);
  }
  if (e.key === "Enter" || e.key === "ArrowDown") {
    focusElemnt(nextId);
    e.preventDefault();
  }
};
export const navigation3 = (e, nextId, prevId, clickFunction = () => { }) => {
  if (e.key === "Escape") {
    focusElemnt(prevId);
  }
  if (e.key === "Enter") {
    focusElemnt(nextId);
    e.preventDefault();
  }
  if (e.keyCode === 32) {
    clickFunction();
  }
};

export const removeDuplicatesFromArray = (array, property) => {
  const uniqueValues = new Set() // Set to store unique property values
  const uniqueArray = [] // Array to store unique objects

  array?.forEach((obj) => {
    const propertyValue = obj[property] // Get the property value of the current object

    if (!uniqueValues.has(propertyValue)) {
      // If property value is not already in the set
      uniqueValues.add(propertyValue) // Add it to the set
      uniqueArray.push(obj) // Add the object to the unique array
    }
  })

  return uniqueArray
}

export const seatDataCombine = (value, generalCon = []) => {
  if (value) {
    return `1~${value?.SeatNo}~${value?.passengerName}~${value?.passengeGender?.[0]?.id || 'M'}~${value?.passengerAge}~${value?.fare}~${value?.psgNationality?.[0]?.CountryName || ''}~~~~0~0~${value?.bfAmt}~${value?.efAmt}~${value?.InfraFee}~${value?.arfAmt}~${value?.seatRes}~${value?.tfAmt}~${value?.ufAmt}~${value?.psgNationality?.[0]?.CountryID === 1 ? value?.passengeConcession?.[0]?.ConcessionTypeID : generalCon.length !== 0 ? generalCon?.[0]?.ConcessionTypeID : 0}~${value?.seatCon}~${value?.psgNationality?.[0]?.CountryID === 1 ? value?.passengeConcession?.[0]?.ConcessionID : generalCon.length !== 0 ? generalCon?.[0]?.ConcessionID : 0}~${value?.refNumber}~${value?.psgNationality?.[0]?.CountryID === 1 ? "" : value?.passportDate}~${value?.psgNationality?.[0]?.CountryID === 1 ? "" : value?.passWordNumber}~${value?.psgNationality?.[0]?.CountryID === 1 ? "" : value?.addressIndia}~${value?.seatDis}`
    // return `1~${value?.SeatNo}~${value?.passengerName}~${value?.passengeGender?.[0]?.id || 'M'}~${value?.passengerAge}~${value?.fare}~${value?.psgNationality?.[0]?.CountryName || ''}~~~~0~0~${value?.bfAmt}~${value?.efAmt}~${value?.InfraFee}~${value?.arfAmt}~${value?.seatRes}~${value?.tfAmt}~${value?.ufAmt}~${value?.psgNationality?.[0]?.CountryID === 1 ? value?.passengeConcession?.[0]?.ConcessionTypeID : 0}~${value?.seatCon}~${value?.psgNationality?.[0]?.CountryID === 1 ? value?.passengeConcession?.[0]?.ConcessionID : 0}~${value?.refNumber}~${value?.psgNationality?.[0]?.CountryID === 1 ? "" : value?.passportDate}~${value?.psgNationality?.[0]?.CountryID === 1 ? "" : value?.passWordNumber}~${value?.psgNationality?.[0]?.CountryID === 1 ? "" : value?.addressIndia}~${value?.seatDis}`
  } else {
    return `1~~~M~0~0~~~~~0~0~0~0~0~0~0~0~0~0~0~0~~~~~`
  }
}
export const checkEmailValid = (val) => {
  if (val.length) {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test(val);
  }
  else
    return true;
}

export const checkPhoneValid = (val) => {
  if (!val) return false; // Return false for empty input

  const phoneReg = /^[6-9]\d{9}$/;
  return phoneReg.test(val);
};

export const checkGSTValid = (val) => {
  if (val.length) {
    const gstReg = new RegExp('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9A-Z]{1}$');
    return gstReg.test(val);
  }
  else
    return true;
}


export const seatModifyDataCombine = (value) => {
  if (value) {
    return `1~${value?.SeatNo}~${value?.PaxName}~${value?.Gender}~${value?.Age}`
  } else {
    return `1~~~M~`
  }
}


export const transferArrToObject = (arr) => {
  const newObject = arr.reduce((result, obj) => {
    Object.keys(obj).forEach(key => {
      result[key] = result[key] ? `${result[key]},${obj[key]}` : `${obj[key]}`;
    });
    return result;
  }, {});
  return newObject
}

export const rgbStringToHex = (rgbString) => {
  // Split the string into individual components
  const rgbArray = rgbString.split(',');

  // Convert each component to hexadecimal
  const r = parseInt(rgbArray[0], 10).toString(16).padStart(2, '0');
  const g = parseInt(rgbArray[1], 10).toString(16).padStart(2, '0');
  const b = parseInt(rgbArray[2], 10).toString(16).padStart(2, '0');

  // Combine the components into a hexadecimal color code
  const hexColor = `#${r}${g}${b}`;

  return hexColor;
}
export const showAndHiddenMenu = (array, jobID, conditionArray) => {
  const filteredArray = array.filter(obj => obj.JobID === jobID);
  if (filteredArray.length === 0) {
    return false;
  }
  if (conditionArray.length == 0) {
    return true
  }
  return (conditionArray.map((val) => filteredArray?.[0]?.[val] === 1 ? 1 : 0)).some((obj) => obj === 1)
}

export const showAndHiddenMainMenu = (array, array1, masterID) => {
  const filteredArray = array.filter(obj => obj.MasterID === masterID);
  if (filteredArray.length === 0) {
    return false;
  }

  return (array1.map((val) => showAndHiddenMenu(filteredArray, val.jobID, val.condition))).some((obj) => obj === true)
}

export const showFareMenu = (array, masterID) => {
  const filteredArray = array.filter(obj => obj.MasterID === masterID);
  if (filteredArray.length === 0) {
    return false;
  } else {
    return filteredArray?.some((obj) => obj?.IsActive === 1)
  }
}

export const checkPanValid = (val) => {
  if (val.length) {
    const panReg = new RegExp('^[A-Z]{5}[0-9]{4}[A-Z]{1}$');
    return panReg.test(val);
  }
  else
    return true;
}


export const strongPassword = (val) => {
  const password = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$');
  return password.test(val);
}


export const compareData = (oldData, newData) => {
  const differences = Object.keys(newData).reduce((acc, key) => {
    const newValueIsDate = moment(newData[key], moment.ISO_8601, true).isValid();
    const oldValueIsDate = moment(oldData[key], moment.ISO_8601, true).isValid();
    if (newData[key] !== oldData[key] && !(newValueIsDate && oldValueIsDate)) {
      acc.push({
        key,
        newValue: newData[key],
        oldValue: oldData[key]
      });
    } else if (newValueIsDate && oldValueIsDate) {
      const newMoment = moment(newData[key]);
      const oldMoment = moment(oldData[key]);
      if (!newMoment.isSame(oldMoment)) {
        acc.push({
          key,
          newValue: newData[key],
          oldValue: oldData[key]
        });
      }
    }
    return acc;
  }, []);
  return differences;
}
export const compareDataOnlyKey = (oldData, newData, arrayKey = [], keyName = {}) => {
  const differences = arrayKey.reduce((acc, key) => {
    const newValueIsDate = moment(newData[key], moment.ISO_8601, true).isValid();
    const oldValueIsDate = moment(oldData[key], moment.ISO_8601, true).isValid();
    if (newData[key] != oldData[key] && (oldData?.hasOwnProperty(key) && newData?.hasOwnProperty(key)) && !(newValueIsDate && oldValueIsDate)) {
      acc.push({
        key: Object.keys(keyName).length > 0 && keyName?.hasOwnProperty(key) ? keyName[key] : key,
        newValue: newData[key], oldValue: oldData[key]
      });
    } else if (newValueIsDate && oldValueIsDate) {
      const newMoment = moment(newData[key]);
      const oldMoment = moment(oldData[key]);
      if (!newMoment.isSame(oldMoment)) {
        acc.push({
          key: Object.keys(keyName).length > 0 && keyName?.hasOwnProperty(key) ? keyName[key] : key,
          newValue: newData[key],
          oldValue: oldData[key]
        });
      }
    }
    return acc;
  }, []);
  return differences;
}

// mappingKey={newData:oldData}
export const compareDataOnlyKeyAndMappingKey = (oldData, newData, arrayKey = [], mappingKey = {}, keyName = {}) => {
  const differences = arrayKey.reduce((acc, key) => {
    if (mappingKey.hasOwnProperty(key) && (newData?.hasOwnProperty(key) && oldData?.hasOwnProperty(mappingKey[key])))
      if (newData[key] != oldData[mappingKey[key]]) {
        acc.push({
          key: Object.keys(keyName).length > 0 && keyName?.hasOwnProperty(key) ? keyName[key] : key,
          oldValue: oldData[mappingKey[key]],
          newValue: newData[key]
        });
      }
    return acc;
  }, []);
  return differences;
}


export const AddcompareData = (newData) => {
  const differences = Object.keys(newData).reduce((acc, key) => {
    acc.push({
      key,
      newValue: newData[key],
      oldValue: ''
    });
    return acc;
  }, []);
  return differences;
}

export const AddCompareDataOnlyKey = (newData, arrayKey = [], keyName = {}) => {
  const differences = arrayKey.reduce((acc, key) => {
    acc.push({
      key: Object.keys(keyName).length > 0 && keyName?.hasOwnProperty(key) ? keyName[key] : key,
      newValue: newData[key],
      oldValue: ''
    });
    return acc;
  }, []);
  return differences;
}

export const isEmpty = (obj) => {
  return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype
}
// Helper function to parse date
export const parseDate = (dateStr) => {
  const [day, month, year] = dateStr.split('-');
  const monthIndex = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN",
    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"].indexOf(month.toUpperCase());
  return new Date(year, monthIndex, day);
}
export const getMonthNames = (fromDate, toDate) => {
  // const monthNames = ["January", "February", "March", "April", "May", "June",
  //   "July", "August", "September", "October", "November", "December"];
  const monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
    "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];

  const from = parseDate(fromDate);
  const to = parseDate(toDate);

  const fromMonthName = monthNames[from.getMonth()];
  const toMonthName = monthNames[to.getMonth()];

  if (fromMonthName === toMonthName) {
    return fromMonthName;
  } else {
    return `${fromMonthName} - ${toMonthName}`;
  }
}

export const transparentStyle = {
  backgroundColor: 'transparent',
  boxShadow: 'none',
  marginRight: '0',
  color: "#004F9E",
  fontWeight: 'bold',
  fontSize: "12px"
}
export const numberToWords = (num) => {
  const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  const convert = (num) => {
    if (num === 0) return '';
    else if (num < 10) return ones[num];
    else if (num < 20) return teens[num - 10];
    else return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + ones[num % 10] : '');
  };

  const convertThousands = (num) => {
    let words = '';

    if (num >= 1000) {
      words += convertThousands(Math.floor(num / 1000)) + ' Thousand ';
      num %= 1000;
    }

    if (num >= 100) {
      words += ones[Math.floor(num / 100)] + ' Hundred ';
      num %= 100;
    }

    if (num > 0) {
      if (words !== '') words += 'and ';
      words += convert(num);
    }

    return words.trim();
  };

  if (num === 0) return 'Zero';
  num = num + ""
  let [integerPart, decimalPart] = num.toString().split('.').map(Number);
  let words = convertThousands(integerPart);

  if (decimalPart !== undefined) {
    words += ' Point';
    decimalPart.toString().split('').forEach(digit => {
      words += ' ' + ones[Number(digit)];
    });
  }

  return words.trim();
};
export const debounce = (func, delay) => {
  let timeoutId;
  return function (...args) {
    const context = this;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(context, args), delay);
  };
};

export const formatDecimalNumber = (num) => {
  if (Number(num) % 1 !== 0) {
    return Number(Number(num).toFixed(1)); // Divide by 10 and remove decimals
  } else {
    return Number(num); // Keep one decimal place
  }
}
export const useDebouncedHandler = (callback, delay = 500) => {
  const timer = useRef(null);

  return useCallback((...args) => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      callback(...args);
    }, delay);
  }, [callback, delay]);
};

export const transferArrToObjectWIthCaret = (arr) => {
  const newObject = arr.reduce((result, obj) => {
    Object.keys(obj).forEach(key => {
      result[key] = result[key] ? `${result[key]}^${obj[key]}` : `${obj[key]}`;
    });
    return result;
  }, {});
  return newObject
}
export const combineDateTime = (dateStr, timeStr) => {
  if (!dateStr || !timeStr) return "";

  const dates = dateStr.split("^");
  const times = timeStr.split("^");

  return dates
    .map((date, i) => `${date} ${times[i] || ""}`)
    .join("^");
};
export function formatWithCurrentDate(data) {
  if (!Array.isArray(data) || data.length === 0) return null;

  const time = data[0].name; // get '01:00'

  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');

  const formattedTime = time.length === 5 ? `${time}:00` : time;

  return `${year}-${month}-${day} ${formattedTime}`;
}
export function getTimeObject(dateTimeString, timeArray) {
  if (!dateTimeString || !timeArray) return [];

  // Extract HH:mm from "YYYY-MM-DD HH:mm:ss"
  const timePart = dateTimeString.split(" ")[1]?.slice(0, 5);

  // Filter matching time
  return timeArray.filter(item => item.name === timePart);
}
